// This file added by Bearer Web Developer
function isElementFullyInViewport(el: HTMLDivElement, parentEl?: HTMLDivElement | null, offset: number = 0) {
    const rect = el.getBoundingClientRect();
    const parentRect = parentEl
        ? parentEl.getBoundingClientRect()
        : {
            top: 0,
            left: 0,
            bottom: window.innerHeight || document.documentElement.clientHeight,
            right: window.innerWidth || document.documentElement.clientWidth,
        };
    return (
        rect.top + offset >= parentRect.top &&
        rect.left + offset >= parentRect.left &&
        rect.bottom - offset <= parentRect.bottom &&
        rect.right - offset <= parentRect.right
    );
}
export default isElementFullyInViewport;